<template>
  <div class="navbar">
    <span  class="nav-title">
      <template v-if="userInfo.role == 1 || userInfo.role == 3">{{ userInfo.login }}安全培训系统</template>
    </span>
    <!-- <Screenfull /> -->
    <div class="right-menu">
        <el-popover
        placement="bottom-end"
        style="padding: 0;margin-right: 20px"
        title=""
        popper-class="login-popover"
        width="180"
        trigger="hover"
        v-if="ewmInfo.organ_ewm || ewmInfo.organ_xcxewm"
        >
        <div class="img-container">
          <template v-if="ewmInfo.organ_ewm">
            <img :src="ewmInfo.organ_ewm" alt="">
            <p>扫描关注公众号</p>
          </template>
          <img v-if="ewmInfo.organ_xcxewm" :src="ewmInfo.organ_xcxewm" alt="">
        </div>
        <el-button slot="reference" icon='el-icon-s-promotion' type="text" style="height: 34px;margin-left: 30px;">公众号</el-button>
      </el-popover>
      <el-tooltip effect="dark" :content="message ? `有${message}条未读消息` : `消息中心`" placement="bottom">
          <el-badge :value="message" class="item">
            <img src="@/assets/images/icon_bell.png" class="btn-bell" alt="" @click="toTabs">
          </el-badge>
      </el-tooltip>
      <i class="el-icon-info btn-help" @click="handleJump" v-if='userInfo.role == 1'></i>
      <img :src="userInfo.headimg" v-if='userInfo.headimg' alt="" class='headimg'>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          {{loginUserName}}
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="handleEditPwd">
            <span>修改密码</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import { getUnReadMessageCount } from '@/api/system'
import { organEwmDetail } from '@/api/user'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    SizeSelect
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device',
      'userInfo'
    ])
  },
  methods: {
    handleJump() {
      this.$router.push('/page/help')
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      // this.$confirm('是否确定退出当前账户', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(async() => {
        await this.$store.dispatch('user/logout')
        this.$store.dispatch('tagsView/delAllViews')
        // this.$router.push(`/login`)
        window.location.reload()
      // })
    },
    getLoginUserInfo() {
      const user = JSON.parse(localStorage.getItem('userInfo'))
      this.loginUserName = user.role == 3 ? user.compname : user.role == 1 ? user.login : user.role == 5 ? user.login : user.uname
    },
    handleEditPwd() {
      this.$Model({
        dialogType: 'pwdEdit',
        title: '修改密码'
      }).then(async res => {
        await this.$store.dispatch('user/logout')
        this.$store.dispatch('tagsView/delAllViews')
        // this.$router.push(`/login`)
        window.location.reload()
      })
    },
    toTabs() {
      this.$router.push('/tab/manage')
    },
    async initData() {
      getUnReadMessageCount().then(res => {
        res = res.data
        if (res.status == 1) {
          this.message = res.data
        }
      })
      organEwmDetail().then(res => {
        res = res.data
        if (res.status == 1) {
          this.ewmInfo = res.data
        }
      })
    }
  },
  data() {
    return {
      loginUserName: '',
      schoolInfo: {},
      currentTime: 0,
      message: 0,
      ewmInfo: {
        organ_ewm: '',
        organ_xcxewm: ''
      }
    }
  },
  created() {
    this.getLoginUserInfo()
    this.initData()
    setInterval(() => {
      this.initData()
    }, 30000)
  },
}
</script>

<style lang="scss" scoped>
.img-container{
  text-align: center;
  img{
    width: 100%;
    &.xcx{
      padding: 0 5px;
    }
  }
}
.headimg{
  width: 35px;
  height: 35px;
  border-radius: 50%;
  margin: 0 5px;
}
.nav-title{
  margin-left: 274px;
  font-size: 16px;
  flex: 1;
  text-align: center;
  font-size: 20px;
}
.navbar {
  height: 80px;
  line-height: 80px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0px 1px 4px 0px rgba(0, 21, 41, 0.12);
  display: flex;
  justify-content: space-between;
  .navbar-title{
    float: left;
    display: flex;
    align-items: center;
    padding-left: 20px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #000000;
    img{
      margin-right: 8px;
      width: 30px;
      height: 30px;
    }
  }
  .btn-bell{
    width: 18px;
    cursor: pointer;
    margin-right: 10px;
    position: relative;
    top: 4px;
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .btn-help{
    color: #999;
    font-size: 20px;
    cursor: pointer;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 56px;
    display: flex;
    align-items: center;
    &:focus {
      outline: none;
    }
    .school-info{
      font-size: 12px;
      font-weight: 500;
      color: #000000;
      height: 30px;
      border-right: 1px solid #EFF2F8;
      line-height: 30px;
      padding-right: 20px;
      margin-right: 20px;
    }
    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 16px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        // margin-top: 5px;
        position: relative;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #006EFF;
        height: 80px;
        line-height: 80px;
        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 35px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
